// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__26mzW","toolbar":"Text_toolbar__1Y5uy","toolbarButton":"Text_toolbarButton__3vFfM","editor":"Text_editor__1LTZg","flex1":"Text_flex1__ijktp"};